<template>
  <div v-if="show && text !== ''" role="alert" class="alert alert-danger d-flex lg-text align-items-baseline justify-content-between">
    <p>
      {{ text }}
    </p>
    <button class="w-25 redButton-outline h-auto p-2 m-0" @click="closeAlert">
      {{ $t("close") }}
    </button>
  </div>
</template>

<script>
import fa from "../../lang/fa";

export default {
  name: "redToast",
  props: {
    text: {
      type: String,
      default: "",
    },
    timeout: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    closeAlert() {
      this.show = false;
      this.$emit("update:text", "");
    },
  },
  watch: {
    text: {
      handler(n) {
        if (n !== "") {
          this.show = true;
          setTimeout(() => {
            this.show = false;
            this.$emit("update:text", "");
          }, this.timeout);
        }
      },
    },
  },
};
</script>

<style scoped></style>
